import React, { useContext, useState, useEffect } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../../Contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import SpinnerLoading from "../../Common/SpinnerLoading";
import ListAdminButtons from "../../Common/ListAdminButtons";
import Tooltip from "../../Common/Tooltip";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { predispositionService } from "../../../Services/AccountingServices/predisposition.service";
import Select from "react-select";
import { globalServices } from "../../../Services/global.service";
import DatePicker, { registerLocale } from "react-datepicker";
import ActionModal from "../../Common/ActionModal";
import ResultModal from "../../Common/ResultModal";
import AsyncSelect from "react-select/async";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import moment from "moment";
import { roles } from "../../../Config/Roles";
registerLocale("hr", hr);
registerLocale("en", en);

const Index = () => {
  const {
    updateLocName,
    updateLocTenant,
    updateLocStore,
    updateLocPos,
    updateLocTab,
    updateLocKey,
    isMobile,
    selectedLanguageId,
  } = useContext(GlobalContext);
  const { userId, useAccounting, roleId } = useContext(AuthContext);
  const { t: translator } = useTranslation();
  const history = useHistory();
  const [update, setUpdate] = useState(new Date());
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [stores, setStores] = useState([]);
  const { control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    searchText: "",
    sortName: "DocumentDate",
    storeId: 0,
    isAsc: false,
    dateFrom: null,
    dateTo: null,
  });

  const [actionModal, setActionModal] = useState({
    title: "",
    text: "",
    show: false,
    confirmBtn: "",
  });

  const [modal, setModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
  });

  const handleClose = () => {
    setModal({ show: false });
  };

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenantsRobno(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        if (Number(roleId) === roles.owner && result.length === 1) {
          const tenant = result.find((x) => x.id === search.tenantId) || null;
          setValue("tenantId", tenant);
          handleOnChangeTenantId(tenant ? [tenant] : null);
        }

        if (!(Number(localStorage.getItem("tenantId")) > 0)) {
          result.unshift({
            id: 0,
            label: translator("Select-Tenant"),
            oib: "",
          });
        }
        return result;
      })
      .catch((err) => err);
  };

  useEffect(() => {
    if (!useAccounting) history.push("/error-page/401");

    updateLocName("predisposition");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
    updateLocKey(0);

    var m = moment();
    var dateTo = moment(search.dateTo);
    m.set(dateTo.toObject());

    predispositionService
      .documentSearch(
        search.tenantId,
        pagination.pageIndex,
        pagination.pageSize,
        search.sortName,
        search.isAsc,
        search.storeId,
        search.searchText,
        search.dateFrom,
        dateTo.endOf("day"),
      )
      .then((res) => {
        setDocuments(res.data.data);
        setPagination({ ...pagination, totalCount: res.data.totalCount });
        setIsLoading(false);
      })
      .catch((err) => console.log(err));
  }, [update, search]);

  const handleTableChange = (type, { page, sizePerPage }) => {
    setIsLoading(true);
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });
    setUpdate(new Date());
  };

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    }).format(new Date(cell));
  }

  const sorting = (sortName) => {
    setSearch({ ...search, sortName, isAsc: !search.isAsc });
  };

  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedItems([...selectedItems, row.documentId]);
    } else {
      setSelectedItems(selectedItems.filter((p) => p !== row.documentId));
    }
  };

  const handleOnSelectAll = (isSelect) => {
    if (isSelect) {
      setSelectedItems(documents.map((x) => x.documentId));
    } else {
      setSelectedItems([]);
    }
  };

  const handleToAdd = () => {
    history.push("/predisposition-create");
  };

  const handleToDetail = () => {
    if (selectedItems.length !== 1) return false;
    history.push(`/predisposition-details/${selectedItems}`);
  };

  const handleDelete = () => {
    setActionModal({
      title: "Predisposition-DocumentDelete-Title",
      text: "Predisposition-DocumentDelete-Text",
      confirmBtn: "Confirm-Delete",
      confirmAction: confirmDelete,
      show: true,
    });
  };

  const handleHideActionModal = () =>
    setActionModal({ ...actionModal, show: false });

  const confirmDelete = () => {
    let deletePromises = [];

    selectedItems.forEach((x) => {
      deletePromises.push(predispositionService.documentDelete(x));
    });

    Promise.all(deletePromises)
      .then((data) => {
        setActionModal({ ...actionModal, show: false });
        if (data[0].data.success) {
          setModal({
            ...modal,
            title: "Predisposition-ResultModal-DeleteSuccess-Title",
            text: "Predisposition-ResultModal-DeleteSuccess-Text",
            show: true,
            btnClass: "btn btn-primary",
          });
          setSelectedItems([]);
          setUpdate(new Date());
        } else {
          setModal({
            ...modal,
            title: "Predisposition-ResultModal-DeleteError-Title",
            text: translator(data[0].data.message),
            show: true,
            btnClass: "btn btn-primary",
          });
        }
      })
      .catch((err) =>
        setModal({
          ...modal,
          title: "Predisposition-ResultModal-DeleteError-Title",
          text: "Predisposition-ResultModal-DeleteError-Text",
          show: true,
          btnClass: "btn btn-primary",
        }),
      );
  };

  function actionFormatter(cell, row) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={selectedItems.find((x) => x === row.documentId)}
            onChange={(e) => handleOnSelect(row, e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  function actionHeaderFormatter(cell, rows) {
    return (
      <div className="action">
        <label className="labelCont">
          <input
            type="checkbox"
            checked={
              documents &&
              documents.length > 0 &&
              !documents
                .map((p) => p.documentId)
                .some((p) => selectedItems.indexOf(p) < 0)
            }
            onChange={(e) => handleOnSelectAll(e.target.checked)}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    );
  }

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (e.target.cellIndex) {
        history.push(`/predisposition-details/${row.documentId}`);
      }
    },
  };

  const columns = [
    {
      dataField: "documentId",
      text: "",
      headerStyle: (colum, colIndex) => {
        return { width: "50px", textAlign: "center" };
      },
      headerFormatter: actionHeaderFormatter,
      formatter: actionFormatter,
    },
    {
      dataField: "date",
      text: translator("Predisposition-TableHeader-Date"),
      headerEvents: { onClick: () => sorting("DocumentDate") },
      formatter: dateTimeFormatter,
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "DocumentDate")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "DocumentDate") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
    },
    {
      dataField: "storeName",
      text: translator("Predisposition-TableHeader-Store"),
      hidden: Boolean(isMobile),
    },
    {
      dataField: "documentNumber",
      text: translator("Predisposition-TableHeader-DocumentNumber"),
      headerEvents: { onClick: () => sorting("DocumentNumber") },
      sort: true,
      sortCaret: (order, column) => {
        if (search.sortName !== "DocumentNumber")
          return <i className="fa fa-fw fa-sort"></i>;
        if (search.sortName === "DocumentNumber") {
          return search.isAsc !== true ? (
            <i className="fa fa-fw fa-sort-up"></i>
          ) : (
            <i className="fa fa-fw fa-sort-down"></i>
          );
        }
      },
    },
    {
      dataField: "note",
      text: translator("Predisposition-TableHeader-Note"),
      hidden: Boolean(isMobile),
    },
  ];

  const RemoteAll = ({ data, page, sizePerPage, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        remote
        keyField="documentId"
        rowStyle={(c) => {
          if (c.parentGuid) {
            return {
              background:
                window.REACT_APP_ALERT_COLOR.slice(0, -2) + "55",
            };
          }
        }}
        data={data}
        rowEvents={rowEvents}
        columns={columns}
        rowClasses="boostrap-table-row"
        noDataIndication={translator("No-Data")}
        pagination={paginationFactory({
          page,
          sizePerPage,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  const handleOnChangeTenantId = (event) => {
    if (!event) return;
    setSearch({ ...search, tenantId: event[0].id });
    globalServices
      .getStoresByTenantId(event[0].id)
      .then((res) => {
        setStores(res.data);
        setValue("storeId", null);
      })
      .catch((err) => console.log(err));

    return event[0];
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("Predisposition-List-Title")}</span>{" "}
          {!isLoading ? (
            <span className="badge badge-pill badge-primary">
              {" "}
              {pagination.totalCount}
            </span>
          ) : null}
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {translator("Predisposition-List-Filters")}
            </legend>
            <form
              className="row"
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                <label htmlFor="ddlTenants">
                  {translator("InvIssReport-Filters-Tenants")}
                </label>
                <Controller
                  as={AsyncSelect}
                  control={control}
                  name="tenantId"
                  rules={{
                    validate: function (value) {
                      if (!value) return false;
                      return value.value === 0 ? false : true;
                    },
                  }}
                  onChange={handleOnChangeTenantId}
                  defaultOptions={true}
                  loadOptions={promiseOptions}
                  placeholder={translator("Select-Tenant")}
                />
              </div>
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label htmlFor="ddlStore">
                  {translator("POS-New_EditPOS-Store")}
                </label>{" "}
                {stores && (
                  <Controller
                    as={Select}
                    options={
                      stores &&
                      stores.map((p) => ({
                        id: p.id,
                        label: p.name,
                        value: p.id,
                      }))
                    }
                    name="storeId"
                    control={control}
                    placeholder={translator("Select-Store")}
                    onChange={function (event) {
                      setSearch({ ...search, storeId: event.id });
                      return event[0];
                    }}
                  />
                )}
              </div>
              <div className="form-group col-lg-3 col-md-4 col-xs-12">
                <label>{translator("Documents-Filters-SearchText")}</label>{" "}
                <Tooltip text={translator("InitialStateTooltip-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  value={search.searchText}
                  onChange={(event) => {
                    setIsLoading(true);
                    setSearch({ ...search, searchText: event.target.value });
                    setPagination({ ...pagination, pageIndex: 0 });
                  }}
                />
              </div>
              <div className="container-fluid row">
                <div className="form-group ml-3">
                  <label>{translator("Predisposition-DateFrom")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <DatePicker
                      autoComplete="off"
                      showYearDropdown={true}
                      className="form-control"
                      dateFormat="dd.MM.yyyy"
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      onChange={(date) =>
                        setSearch({ ...search, dateFrom: date })
                      }
                      selected={search.dateFrom}
                      maxDate={
                        search.dateTo !== null ? new Date(search.dateTo) : ""
                      }
                    />
                  </div>
                </div>
                <div className="form-group col-lg-3 col-md-4 col-xs-12">
                  <label>{translator("Predisposition-DateTo")}</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon1">
                        <img src={iconcontentcalendar} alt="calendar" />
                      </span>
                    </div>
                    <DatePicker
                      autoComplete="off"
                      showYearDropdown={true}
                      className="form-control"
                      dateFormat="dd.MM.yyyy"
                      locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                      onChange={(date) =>
                        setSearch({ ...search, dateTo: date })
                      }
                      selected={search.dateTo}
                      minDate={
                        search.dateFrom !== null
                          ? new Date(search.dateFrom)
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </form>
          </fieldset>
          <ListAdminButtons
            handleToAdd={handleToAdd}
            handleToDetail={handleToDetail}
            handleDelete={handleDelete}
            selectedItemsLength={selectedItems.length}
          />

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={documents}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}
        </div>
      </div>
      <ActionModal
        show={actionModal.show}
        handleHide={handleHideActionModal}
        title={actionModal.title}
        text={actionModal.text}
        confirmBtn={actionModal.confirmBtn}
        confirmAction={actionModal.confirmAction}
      />
      <ResultModal
        show={modal.show}
        title={modal.title}
        text={modal.text}
        btnClass={modal.btnClass}
        handleClose={handleClose}
      />
    </div>
  );
};

export default Index;
